<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa fa-map-signs" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm" variant="primary" @click="adminEmailTemplateAdd">{{cvbtnAddNew}}</b-button>
          </div>
        </div>
        <div class="iq-card p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
          <b-row>
            <b-col class="col-12 col-sm-4 mb-3">
              <!-- Backend Search -->
              <b-form-input class="form-control"
                @input="searchadminemailtempWithParams"
                v-model="search_param"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
            </b-col><!-- Backend Search -->
            <b-col class="col-12 col-sm-4 mb-2 ">
              <select v-model="domain_filter" class="form-control" @change="setFilters('domain')" title="Domain Filter">
                <option disabled value="">Choose Domain</option>
                <option :value="null">All</option>
                <option v-for="(domain, index) of appDomain" :key="index+1" :value="domain">
                  {{domain}}
                </option>
              </select>
            </b-col>
            <!-- admin Email TempName Filter -->
            <div class="col-12 col-sm-4 mb-3">
              <select v-model="module_name" class="form-control" @change="setFilters()" >
                <option :value="null" disabled>Choose Module Name</option>
                <option style="text-transform: capitalize;"
                  v-for="(name, index) in adminEmailTempFilterList.module_name"
                  :key="'email_temp_' + index"
                  :value="name.module_name">
                  {{ name.module_name }}
                </option>
                <option value="">All</option>
              </select>
            </div><!-- admin Email TempName Filter -->
          </b-row>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="adminemailtempObjList && adminemailtempObjList.length > 0">
            <b-table
              hover
              responsive
              :items="adminemailtempObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(email_template_id)="data">
                <span><b>
                  {{ data.item.email_template_name }}<br>
                  <small>
                    Id: {{data.item.email_template_id}}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.email_template_id)"></i>
                  </small>
                </b><br></span>
                <b-button variant="mr-1 mb-1 actionIcon" size="sm" @click="adminEmailTemplateEdit('MODAL', data.item)" v-if="!data.item.editable"><i class="ri-ball-pen-fill m-0 font-size-20"></i></b-button>
                <b-button variant="actionIcon" @click="showadminEmailTemplateDeleteDialog(data.item)" size="sm"><i class="ri-delete-bin-line m-0 font-size-20"></i></b-button>
                <b-button variant="actionIcon" @click="showadminEmailTemplateViewDialog(data.item)" size="sm"><i class="fa fa-eye m-0 font-size-20"></i></b-button>
                <b-button class="ml-2 actionIcon" size="sm" @click="adminEmailTemplateAdd('MODAL', data.item)"><i class="fa fa-files-o font-size-20" title="Duplicate This Email Template"></i></b-button><br>
                <span class="primary-color">{{ data.item.app_domain }}</span>
              </template>
              <template v-slot:cell(module_object_id)="data">
                <span v-if="data.item.module_name">
                  {{ data.item.module_name }}<br>
                  <small>
                    Id: {{data.item.module_object_id}}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.module_object_id)"></i>
                  </small>
                </span>
                <span v-else>----</span>
              </template>
              <template v-slot:cell(email_subject)="data">
                <span class="pointer" @click="showadminEmailTemplateViewDialog(data.item)">
                  <span>Subject:&nbsp;{{data.item.email_subject}}</span><br><br>
                  <small><span v-html="data.item.email_body.slice(0, 100)+' ...'"></span></small>
                </span>
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
          <b-col sm="5" md="5">
            <b-pagination
              v-model="currentBatchNo"
              :total-rows="totalRows"
              :per-page="dataPerPage"
              align="fill"
              size="sm"
              class="my-0"
            ></b-pagination>
          </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModeladminEmailTemplateAdd"
      scrollable
      :title="cvAddModalHeader"
      size="xxl"
    >
      <adminEmailTemplateAdd :propOpenedInModal="true" :propAdminEmailTempDuplicateObj="AdminEmailTempDuplicateObj" @emitCloseadminEmailTemplateAddModal="closeadminEmailTemplateAddModal"/>
      <template #modal-footer="">
        <b-button size="sm" @click="closeadminEmailTemplateAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModeladminEmailTemplateEdit"
      scrollable
      :title="cvEditModalHeader"
      size="xxl"
    >
      <adminEmailTemplateEdit :propOpenedInModal="true" :propAdminEmailTempObj="adminEmailTemplateEditObj" @emitCloseadminEmailTemplateEditModal="closeadminEmailTemplateEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeadminEmailTemplateEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModeladminEmailTemplateView"
      scrollable
      :title="cvViewModalHeader"
      size="xxl"
    >
      <adminEmailTemplateView :propOpenedInModal="true" :propAdminEmailTempObj="adminEmailTemplateViewObj" @emitCloseadminEmailTemplateViewModal="closeadminEmailTemplateViewModal" />

      <template #modal-footer="">
        <b-button size="sm" @click="closeadminEmailTemplateViewModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModeladminEmailTemplateDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModeladminEmailTemplateDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="adminEmailTemplateDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { AdminEmailTemplateApiObj } from "../../../FackApi/api/AdminEmailTemplate.js"
import adminEmailTemplateAdd from "./AdminEmailTemplateAdd.vue"
import adminEmailTemplateEdit from "./AdminEmailTemplateEdit.vue"
import adminEmailTemplateView from "./AdminEmailTemplateView.vue"
import ApiResponse from "../../../Utils/apiResponse.js"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import Utility from "../../../Utils/utility.js"
import appDomain from "../../../FackApi/json/Domain.json"

export default {
  name: "adminEmailTemplateList",
  components: {
    adminEmailTemplateAdd,
    adminEmailTemplateEdit,
    adminEmailTemplateView
  },
  data () {
    return {
      cvCardTitle: "Admin Email Template",
      cvbtnAddNew: "Add",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Email Template",
      cvAddModalHeader: "Add Email Template",
      cvViewModalHeader: "View Email Template",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Email Template",
      showModeladminEmailTemplateAdd: false,
      showModeladminEmailTemplateEdit: false,
      showModeladminEmailTemplateDelete: false,
      showModeladminEmailTemplateView: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "Id", class: "text-left align-text-top", sortable: true },
        { label: "Email Template", key: "email_template_id", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Module", key: "module_object_id", class: "text-left align-text-top", sortable: true },
        { label: "AI Actions", key: "action", class: "text-left align-text-top", sortable: true },
        { label: "Email", key: "email_subject", class: "text-left align-text-top w-350px", sortable: true }
      ],
      adminemailtempObjList: [],
      adminEmailTemplateEditObj: null,
      adminEmailTemplateViewObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {},
      search_param: "",
      domain_filter: "",
      module_name: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      adminEmailTempFilterList: {
        email_template_name: []
      },
      doCopy: Utility.doCopy,
      AdminEmailTempDuplicateObj: null,
      appDomain: appDomain
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    this.adminEmailTemplateList()
    this.adminEmailTemplateFilterList("module_name")
  },
  methods: {
    /**
     * searchadminemailtempWithParams
     */
    async searchadminemailtempWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.adminEmailTemplateList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.adminEmailTemplateList(true)
    },
    /**
     * set Filters
     */
    async setFilters () {
      this.adminEmailTemplateList()
    },
    /**
     * adminEmailTemplateList
     */
    async adminEmailTemplateList (loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.domain_name = this.domain_filter
        this.whereFilter.module_name = this.module_name
        let adminEmailTemplateListResp = await AdminEmailTemplateApiObj.adminEmailTemplateList(this, this.whereFilter)
        if (adminEmailTemplateListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.adminemailtempObjList = [ ...adminEmailTemplateListResp.resp_data.data ]
          }
          else {
            this.adminemailtempObjList = [ ...this.adminemailtempObjList, ...adminEmailTemplateListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.adminemailtempObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.adminemailtempObjList.length
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = adminEmailTemplateListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateList() and Exception:", err)
      }
    },
    /**
     * adminEmailTemplateAdd
     */
    adminEmailTemplateAdd (type = "MODAL", item = null) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/email_template_add")
        }
        else {
          if (item) {
            this.AdminEmailTempDuplicateObj = item
          }

          this.showModeladminEmailTemplateAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateAdd() and Exception:", err.message)
      }
    },
    /**
     * adminEmailTemplateEdit
     */
    adminEmailTemplateEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/email_template_edit/" + this.adminEmailTemplateEditObj.email_template_id)
        }
        else {
          this.adminEmailTemplateEditObj = item
          this.showModeladminEmailTemplateEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateEdit() and Exception:", err.message)
      }
    },
    /**
     * showadminEmailTemplateDeleteDialog
     */
    showadminEmailTemplateDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModeladminEmailTemplateDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showadminEmailTemplateDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * adminEmailTemplateDelete
     */
    async adminEmailTemplateDelete () {
      try {
        let adminemailtempDelResp = await AdminEmailTemplateApiObj.adminEmailTemplateDelete(this, this.delObj.email_template_id)
        await ApiResponse.responseMessageDisplay(this, adminemailtempDelResp)

        if (adminemailtempDelResp && !adminemailtempDelResp) {
          this.showModeladminEmailTemplateDelete = false
          return false
        }

        let index = this.adminemailtempObjList.indexOf(this.delObj)
        this.adminemailtempObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModeladminEmailTemplateDelete = false
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateDelete() and Exception:", err.message)
      }
    },
    /**
     * closeadminEmailTemplateAddModal
     */
    closeadminEmailTemplateAddModal () {
      try {
        this.adminEmailTemplateList()
        this.showModeladminEmailTemplateAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closeadminEmailTemplateAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeadminEmailTemplateEditModal
     */
    closeadminEmailTemplateEditModal () {
      try {
        this.showModeladminEmailTemplateEdit = false
        this.adminEmailTemplateList()
      }
      catch (err) {
        console.error("Exception occurred at closeadminEmailTemplateEditModal() and Exception:", err.message)
      }
    },
    /**
     * showadminEmailTemplateViewDialog
     */
    showadminEmailTemplateViewDialog (item) {
      try {
        this.adminEmailTemplateViewObj = item
        this.showModeladminEmailTemplateView = true
      }
      catch (err) {
        console.error("Exception occurred at showadminEmailTemplateDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * closeadminEmailTemplateEditModal
     */
    closeadminEmailTemplateViewModal () {
      try {
        this.showModeladminEmailTemplateView = false
      }
      catch (err) {
        console.error("Exception occurred at closeadminEmailTemplateViewModal() and Exception:", err.message)
      }
    },
    /*
     * admin Email Template FilterList
     */
    async adminEmailTemplateFilterList (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let adminEmailTemplateFilterListResp = await AdminEmailTemplateApiObj.adminEmailTemplateFilterList(this, filterName)
        if (adminEmailTemplateFilterListResp && adminEmailTemplateFilterListResp.resp_status) {
          this.$set(this.adminEmailTempFilterList, filterName, adminEmailTemplateFilterListResp.resp_data)
          console.log("Filter data updated:", this.adminEmailTempFilterList[filterName])
        }
      }
      catch (err) {
        console.error("Exception occurred at adminEmailTemplateFilterList() and Exception:", err.message)
      }
    }
  }
}
</script>
